<template>
  <view class="custom-class goods-card">
    <view class="goods-card__header">
      <view class="goods-card__thumb" @click="onClickThumb">
        <image v-if="thumb" :src="thumb" :mode="thumbMode" :lazy-load="lazyLoad" class="goods-card__img thumb-class" />
        <slot v-else name="thumb" />
        <goods-tag v-if="tag" mark type="danger" custom-class="goods-card__tag">
          {{ tag }}
        </goods-tag>
        <slot v-else name="tag" />
      </view>

      <view class="goods-card__content">
        <view>
          <view v-if="title" class="goods-card__title title-class">{{ title }}</view>
          <slot v-else name="title" />

          <view v-if="desc" class="goods-card__desc desc-class">{{ desc }}</view>
          <slot v-else name="desc" />

          <slot name="tags" />
        </view>

        <view class="goods-card__bottom">
          <slot name="price-top" />
          <view v-if="price || price === 0" class="goods-card__price price-class">
            <text>{{ currency }}</text>
            <text class="goods-card__price-integer">{{ integerStr }}</text>
            <text class="goods-card__price-decimal">{{ decimalStr }}</text>
          </view>
          <slot v-else name="price" />
          <view v-if="originPrice || originPrice === 0" class="goods-card__origin-price origin-price-class">
            {{ currency }} {{ originPrice }}
          </view>
          <slot v-else name="origin-price" />
          <view v-if="num" class="goods-card__num num-class">x {{ num }}</view>
          <view v-else class="goods-card__num num-class">
            <slot name="num" />
          </view>
          <slot name="bottom" />
        </view>
      </view>
    </view>

    <view class="goods-card__footer">
      <slot name="footer" />
    </view>
  </view>
</template>

<script>
export default {
  name: 'GoodsCard',
  props: {
    tag: String,
    num: String,
    desc: String,
    thumb: String,
    title: String,
    price: {
      type: String,
      default: '',
    },
    centered: Boolean,
    lazyLoad: Boolean,
    thumbLink: String,
    originPrice: String,
    thumbMode: {
      type: String,
      default: 'aspectFit',
    },
    currency: {
      type: String,
      default: '¥',
    },
  },
  watch: {
    price: {
      immediate: true,
      handler: function (v) {
        this.updatePrice(v);
      },
    },
  },
  data() {
    return {
      integerStr: null,
      decimalStr: null,
    };
  },
  methods: {
    updatePrice(price) {
      const priceArr = price.toString().split('.');
      this.integerStr = priceArr[0];
      this.decimalStr = priceArr[1] ? `.${priceArr[1]}` : '';
    },
    onClickThumb() {
      console.log('%c [onClickThumb]: ', 'color:#1989fa;');
    },
  },
};
</script>

<style scoped lang="scss">
.goods-card {
  position: relative;
  box-sizing: border-box;
  padding: 8px 16px;
  font-size: 12px;
  color: #323233;
  //background-color: #fafafa;
}
.goods-card__header {
  display: -webkit-flex;
  display: flex;
}
.goods-card__header--center {
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.goods-card__thumb {
  position: relative;
  -webkit-flex: none;
  flex: none;
  width: 88px;
  height: 88px;
  margin-right: 8px;
}
.goods-card__thumb:empty {
  display: none;
}
.goods-card__img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}
.goods-card__content {
  position: relative;
  display: -webkit-flex;
  display: flex;
  -webkit-flex: 1;
  flex: 1;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  min-width: 0;
  min-height: 88px;
}
.goods-card__content--center {
  -webkit-justify-content: center;
  justify-content: center;
}
.goods-card__desc,
.goods-card__title {
  word-wrap: break-word;
}
.goods-card__title {
  font-weight: 700;
  line-height: 16px;
}
.goods-card__desc {
  line-height: 20px;
  color: #646566;
}
.goods-card__bottom {
  line-height: 20px;
}
.goods-card__price {
  display: inline-block;
  font-weight: 700;
  color: #ee0a24;
  font-size: 12px;
}
.goods-card__price-integer {
  font-size: 16px;
}
.goods-card__price-decimal,
.goods-card__price-integer {
  font-family: Avenir-Heavy, PingFang SC, Helvetica Neue, Arial, sans-serif;
}
.goods-card__origin-price {
  display: inline-block;
  margin-left: 5px;
  text-decoration: line-through;
  font-size: 10px;
  color: #646566;
}
.goods-card__num {
  float: right;
}
.goods-card__tag {
  position: absolute !important;
  top: 2px;
  left: 0;
}
.goods-card__footer {
  -webkit-flex: none;
  flex: none;
  width: 100%;
  text-align: right;
}
</style>
